import * as types from "../types/kitchenTables"

const initialState = []

const systemSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_KITCHEN_TABLES:
      return [...action.tables]
    case types.ADD_KITCHEN_TABLE:
      return state.some(t => t._id === action.newTable._id) ?
        state : [action.newTable, ...state]
    case types.EDIT_KITCHEN_TABLE:
      return state.map(t =>
        t._id === action.tableId ?
          { ...t, ...action.newTable } : t
      )
    case types.REMOVE_KITCHEN_TABLE:
      return state.filter(availableTable =>
        availableTable._id !== action.tableId
      )
    default:
      return state
  }
}

export default systemSettingsReducer